import lrCarNumber from './_src/lrCarNumber.vue'

lrCarNumber.install = function(Vue) {
  Vue.component(lrCarNumber.name, lrCarNumber)
}

export default lrCarNumber